module.exports = __webpack_public_path__ + "img/icon6.67062844.png";